import PropTypes from 'prop-types';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import classes from './Addressbook.module.css';
import {getEmployees} from 'redux/actions/Pegawai';
import {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import InfoDialog from '../InfoDialog';
import useModal from 'shared/hooks/useModal';

const AddressbookPegawai = ({
  multiselect,
  setPayloadOnHide,
  setPilihan,
  pilihan,
  searchText,
  setPersonal,
  useCRSFE,
  isTransform
}) => {
  const dispatch = useDispatch();
  let columns;
  columns = useCRSFE ?  [
    {id: 'name', label: 'Nama', minWidth: 170},
    {id: 'nik', label: 'NIP', minWidth: 100},
  ] :
  [
    {id: 'nama', label: 'Nama', minWidth: 170},
    {id: 'nip', label: 'NIP', minWidth: 100},
  ];

  const tmpData = useSelector(({employee}) => {
    if (employee.detail)
      return employee.detail;
    else
      return employee.detail;
  });
  useEffect(() => {
    dispatch(getEmployees(searchText,useCRSFE,isTransform));
  }, [searchText]);
  const [selectedRow, setSelected] = useState(undefined);

  const handleClick = (item) => {
    if(!multiselect) {
      let tmp = {
        id: item.nip?item.nip:item.nik,
        text: item.nama || item.name || item.fullname,
        code: item.nip?item.nip:item.nik,
        oriItem: item,
      };
      setPilihan([tmp]);
    }
    setSelected(item);
    setPersonal(item);
  };

  const handleDoubleClick = (item) => {
    let tmp = {
      id: item.nip?item.nip:item.nik,
      text: item.nama || item.name || item.fullname,
      code: item.nip?item.nip:item.nik,
      oriItem: item,
    };
    if (multiselect) {
      let exist = pilihan.findIndex((item) => {
        return item.code === tmp.code;
      });
      if (exist > -1) {
        setInfo(tmp.text + ' sudah dipilih');
        toggleShowInfo(true);
      } else setPilihan((pilihan) => [...pilihan, tmp]);
    } else {
      setPilihan([tmp]);
      setPayloadOnHide([tmp]);
    }
    setSelected(undefined);
  };

  const {
    stateAddress: stateInfo,
    toggleShow: toggleShowInfo,
    toggleHide: toggleHideInfo,
  } = useModal();
  const [infoMsg, setInfo] = useState('');

  let selected_code = selectedRow ? (selectedRow.nip? selectedRow.nip : selectedRow.nik) : undefined;
  return (
    <Paper sx={{width: '100%', overflow: 'hidden'}}>
      <TableContainer sx={{maxHeight: '100%', overflow: 'hidden'}}>
        <Table stickyHeader size='small' aria-label='sticky table'>
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{minWidth: column.minWidth}}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {tmpData &&
              tmpData.map((row) => {
                return (
                  <TableRow
                    hover
                    role='checkbox'
                    className={
                      selected_code === row.nip || selected_code === row.nik 
                        ? classes.click + ' ' + classes.selected
                        : classes.click
                    }
                    tabIndex={-1}
                    key={row.nip?row.nip:row.nik}
                    onClick={() => handleClick(row)}
                    onDoubleClick={() => handleDoubleClick(row)}
                  >
                    {columns.map((column) => {
                      let value;
                      if (column.id === 'fullname')
                        value = row[column.id].split('/')[1];
                      else value = row[column.id];
                      return (
                        <TableCell key={column.id} align={column.align}>
                          {column.format && typeof value === 'number'
                            ? column.format(value)
                            : value}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <InfoDialog
        stateAddress={stateInfo}
        toggleHide={toggleHideInfo}
        msg={infoMsg}
      />
    </Paper>
  );
};

export default AddressbookPegawai;

AddressbookPegawai.propTypes = {
  multiselect: PropTypes.bool,
  setPayloadOnHide: PropTypes.func,
  setPilihan: PropTypes.func,
  pilihan: PropTypes.array,
  isTransform:PropTypes.bool,
  searchText: PropTypes.any,
  setPersonal: PropTypes.func,
  useCRSFE:PropTypes.any
};
